export const MASTER_CONTACT_EMAIL = "khalid@paramountstudents.com";
